import { WidgetDefinition } from '../';

export const logbookTableWidgetDefinition: WidgetDefinition = {
    baseType: 'LogbookTable',
    group: 'Charts',
    hasImage: true,
    highlights: ['Logbook entries over selected period of time', 'You can select entries according to severity, categories or groups'],
    icon: 'fa-book',
    sortingOrder: 1300,
    title: 'Logbook table',
    type: 'LogbookTable'
};